import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GTMPageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer?.push({
      event: "pageview",
      pagePath: location.pathname + location.search,
    });
  }, [location]);

  return null;
};

export default GTMPageViewTracker;
